import { createAction } from '@reduxjs/toolkit'
export const UPDATE_ACCOUNT_DATA = 'account/UPDATE_ACCOUNT_DATA'
export const UPDATE_PHONE = 'account/UPDATE_PHONE'

export const updateAccountData = createAction(UPDATE_ACCOUNT_DATA)

export const updatePhone = createAction(UPDATE_PHONE)
